export default "__VITE_ASSET__f1ae10ff__";